
import axios from "axios";
import { v4 as uuidv4 } from "uuid";

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:1337/api";

// Create Axios Instance
const axiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 300 * 1000, // 5 minutes timeout
});

// Unique identifiers for each request
axiosInstance.interceptors.request.use((config) => {
  config.headers["x_client_id"] = "cloverbay-website"; 
  config.headers["x_trace_id"] = uuidv4();
  return config;
});


axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("Axios Error:", error);
    return Promise.reject(error);
  }
);

export default axiosInstance;
